<template>
  <div>
    <nav class="nav-bar">
      <router-link to="/" class="home-link">
        <img src="@/assets/home.svg" alt="Home" />
      </router-link>
    </nav>
    <iframe class="show-view" :key="iframeKey" id="myIframe" :src="fileName" @load="onIframeLoad"></iframe>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()
const filePath = route.query.filePath || 'SG-3x9repNREZu_offline1856259074844397568'
const number = route.query.number || 1
const iframeKey = ref(0)

const fileName = computed(() => {
  const name = filePath?.split('_')[0] || 'SG-3x9repNREZu'
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : ''
  const url = `${baseUrl}/${number}/offline.html?m=${name}#/`
  console.log('fileName:', url)
  return url
})

watch(
  () => filePath,
  () => {
    iframeKey.value++
  }
)

function onIframeLoad() {
  console.log('Iframe 加载完成')
}
setTimeout(() => {
  iframeKey.value++
}, 100)
</script>

<style scoped lang="scss">
.show-view {
  width: 100%;
  height: calc(100vh - 51px);
  border: none;
}
.nav-bar {
  display: flex;
  align-items: center;
  background-color: #4a4c51;
  padding: 3px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  .home-link {
    color: white;
    text-decoration: none;
    font-size: 24px;
    margin: 0 20px 0 10px;
    &:hover {
      color: #dfe3ee;
    }
  }

  .nav-link {
    color: white;
    text-decoration: none;
    padding: 10px 20px;
    margin: 0 10px;
    border-radius: 5px;
    transition:
      background-color 0.3s,
      color 0.3s;

    &:hover {
      background-color: #2d4373;
    }

    &.active {
      background-color: #2d4373;
    }
  }
  .upload-button {
    margin-left: auto;
  }
}
</style>
